import { render, staticRenderFns } from "./rupee.vue?vue&type=template&id=8aea16ea"
import script from "./rupee.vue?vue&type=script&lang=js"
export * from "./rupee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports